import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const criteria = ['Sientes ansiedad cuando alguien se aleja', 'Te cuesta soltar una relación', 'Has perdido tranquilidad emocional', 'Sientes vacío emocional o miedo a quedarte solo', 'Quieres volver a sentirte fuerte emocionalmente', 'Deseas recuperar tu paz interior y tu amor propio'];
export function ForYouSection() {
  return <section className="py-24 px-6" data-id="element-84">
      <div className="max-w-4xl mx-auto bg-teal-900 rounded-3xl p-8 md:p-16 shadow-sm border border-cream/10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-87">
            Este entrenamiento es para ti{' '}
            <span className="italic text-terracotta" data-id="element-88">si…</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-89">
          {criteria.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4" data-id="element-90">
              <div className="mt-1 w-6 h-6 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-91">
                <Check className="w-4 h-4 text-terracotta" data-id="element-92" />
              </div>
              <p className="text-lg text-cream/90" data-id="element-93">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}